module.exports = __webpack_public_path__ + "img/eatout-3.0c890422.svg";